import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

/**
 * HausflixNotice — announces the hausflix first contact on the thank-you
 * pages (Stage A of the brand rollout, decided 13.08.).
 *
 * Why: the leadservice now introduces itself as "hausflix on behalf of
 * [company]". Without this announcement the caller would be a stranger to
 * the lead. Shown ONLY for leadservice funnels (someone will actually call);
 * deliberately phrased as verification ("wir prüfen Ihre Angaben"), never as
 * advertising for a "Partnerbetrieb" (team concern, meeting 13.08.).
 */

const ROOF = "#2D5F3F";
const TICK = "#C8623D";

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  text-align: left;
  margin: 20px auto 4px;
  padding: 14px 16px;
  max-width: 460px;
  background: #faf7f2;
  border: 1px solid #e8dcc4;
  border-radius: 10px;
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #444;
`;

const Wordmark = styled.span`
  font-weight: 800;
  color: #2a2724;
  white-space: nowrap;
`;

const LogoIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 100 100"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M14 60 L50 22 L86 60"
      fill="none"
      stroke={ROOF}
      strokeWidth="11"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 56 V82" stroke={ROOF} strokeWidth="11" strokeLinecap="round" />
    <path d="M78 56 V82" stroke={ROOF} strokeWidth="11" strokeLinecap="round" />
    <path
      d="M38 66 L46 74 L62 58"
      fill="none"
      stroke={TICK}
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HausflixNotice = () => {
  const { funnel } = useSelector((state) => state.funnelInfo);
  // Only when the leadservice will actually call this lead — on all other
  // funnel types an announced call would be a false promise.
  if (!funnel?.leadService) return null;
  const companyName = funnel.companyInfo?.companyName;
  return (
    <Card>
      <LogoIcon />
      <Text>
        Wir von{" "}
        <Wordmark>
          haus<span style={{ color: TICK }}>flix</span>
        </Wordmark>{" "}
        prüfen Ihre Angaben und melden uns in Kürze telefonisch bei Ihnen —{" "}
        {companyName ? (
          <>
            im Auftrag von <strong>{companyName}</strong>.
          </>
        ) : (
          <>im Auftrag Ihres Fachbetriebs.</>
        )}
      </Text>
    </Card>
  );
};

export default HausflixNotice;
